import request from '@/utils/request'

export function getInfo() {
    return request({
        url: '/admin/info',
        method: 'get',
    })
}

export function fetchList(params) {
    return request({
        url: '/admin/list',
        method: 'get',
        params: params
    })
}

export function createAdmin(data) {
    return request({
        url: '/admin/create',
        method: 'post',
        data: data
    })
}

export function updateAdmin(id, data) {
    return request({
        url: '/admin/update/' + id,
        method: 'post',
        data: data
    })
}

export function findAdminById(id) {
    return request({
        url: '/admin/findAdminById/' + id,
        method: 'get',
    })
}

//停用用户
export function deleteAdmin(id) {
    return request({
        url: '/admin/deleteById/' + id,
        method: 'post'
    })
}
//激活用户
export function activeAdmin(id) {
    return request({
        url: '/admin/activeUser/' + id,
        method: 'post'
    })
}
export function uploadAvatar(data) {
    return request({
      url: '/admin/uploadAvatar',
      method: 'post',
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/admin.js